/** Fresh presses only; callers own keyboard/pointer repeat and focus gating. */
export function createFlightTap({now=()=>globalThis.performance.now(),windowMs=450}={}) {
  let last=-Infinity,pending=false;
  return {
    press(){const time=now();if(time>=last&&time-last<=windowMs){pending=!pending;last=-Infinity;}else last=time;},
    consume(){const value=pending;pending=false;return value;},
    clear(){last=-Infinity;pending=false;},
  };
}
